import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Accepts all clsx-compatible values and merges with Tailwind
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(...inputs));
}
